export default "__VITE_ASSET__ifFjQVfo__"